import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, UncontrolledTooltip, Input } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import NumberFormatter from '../../../commons/NumberFormatter';
import ProgressButton from '../../../commons/ProgressButton';

// 0 -> Felvitel
// 1 -> módosítás
let _muvelet = 0;
// let modositoObj = null;

class BankszamlaLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ['QUERY', 'LOAD', 'DATA', 'NETW', 'TABL']
      currentStatusBaseTable: 'LOAD',
      errorFromServer: '-',
      submitObj: null,
      idFromForm: null,
      idFromServer: null,
      modalNezet: false,
      modalFelvitel: false,
      modalTorles: false,
      modalValtozas: false,
      dataLoaded: false,
      dataFailed: false,
      baseJson: [],
      aktivBanktipus: [],
      aktivPenznem: [],
      aktivCegadat: [],
      aktivTipusok: [],
      aktivStatuszok: [],
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
      viewObj: null,
      modositoObj: null,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.updateTable = this.updateTable.bind(this);
  }

  componentDidMount() {
    this.getAktivCegadat();
    this.queryAllPenzugyValues();
  }

  // Tab váltás miatt kell adatfrissítés
  queryAllPenzugyValues = () => {
    this.updateTable();
    this.getAktivPenznem();
    this.getAktivBanktipus();
  }

  // /** Dinamikusan töltendő szűkítő feltételek lekérdezése */
  // getEnums = () => {
  //   if (this.props.globals.hasRole(['INFLACIO'])) {
  //     Services.listInflacioEnums((err, res) => {
  //       if (!err) {
  //         let aktivTipusok = res[0][0].map(e => <option key={e.id} value={e.id}>{e.caption}</option>);
  //         let aktivStatuszok = res[0][1].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  //         this.setState({
  //           aktivTipusok: aktivTipusok,
  //           aktivStatuszok: aktivStatuszok
  //         });
  //       }
  //     });
  //   }
  // }


  getAktivPenznem = () => {
    Services.listAktivPenznem(null, null, (err, res) => {
      if (!err) {
        let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        this.setState({ aktivPenznem: resOptions });
      }
    });
  }

  getAktivCegadat = () => {
    Services.listAktivCegadat(null, (err, res) => {
      if (!err) {
        let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.tipus + ')'}</option>);
        this.setState({ aktivCegadat: resOptions });
      }
    });
  }

  getAktivBanktipus = () => {
    Services.listBankttipus((err, res) => {
      if (!err) {
        let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        this.setState({ aktivBanktipus: resOptions });
      }
    });
  }

  /** Objektumot bejárva az üres stringeket NULL-ra állítja */
  emptyToNull = (obj) => {
    if (!obj || typeof obj !== 'object') return;
    for (let p in obj) {
      if (typeof obj[p] === 'object' && obj[p] !== null) {
        this.emptyToNull(obj[p]);
      } else if (obj.hasOwnProperty(p)) {
        if (obj[p] === '' || obj[p] === undefined) {
          obj[p] = null;
        }
      }
    }
  }

  updateTable = () => {
    // this.getEnums();
    this.setState({
      currentStatusBaseTable: 'LOAD'
    });
    Services.listBankszamla((err, res) => {
      if (err) {
        this.setState({
          currentStatusBaseTable: 'NETW'
        });
      } else {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });

        res[0] && res[0].list.forEach((element, idx) => {
          if (element.banktipus && element.banktipus.nev) {
            res[0].list[idx].banknev = element.banktipus.nev;
          }
          if (element.statusz && element.statusz.caption) {
            res[0].list[idx].aktiv = element.statusz.caption === 'Aktív';
          }

          // if (element.cegadattipus && element.cegadattipus.name) {
          //   res[0][idx].cegnev = element.cegadattipus.name;
          // }
        });
        this.setState({
          baseJson: res[0].list,
          statusz: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
          currentStatusBaseTable: res[0].list.length > 0 ? 'TABL' : 'DATA'
        });
      }
    });
  }

  fillModositoObj = () => {
    this.setState({ modifyDataLoaded: false, modfiyDataFailed: false });

    Services.getBankszamla(this._currentEditId, (err, res) => {
      if (err) {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: true });
      } else {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: false });
        let modositoObj = res[0];
        modositoObj.statusz = res[0].statusz && res[0].statusz.name;
        this.setState({ modositoObj: res[0]});
        Services.listAktivCegadat(res[0].cegadatid, (err2, res2) => {
          if (!err2) {
            let resOptions = res2[0].map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.tipus + ')'}</option>);
            this.setState({ aktivCegadat: resOptions }, () => {
              this.toggleFelvitel();
            });
          }
        });

        Services.listAktivPenznem(res[0].penznemid, true, (err3, res3) => {
          if (!err3) {
            let resOptions = res3[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
            this.setState({ aktivPenznem: resOptions });
          }
        });
      }
    });
  }

  getViewObj = () => {
    Services.viewBankszamla(this._currentViewId, (err, res) => {
      if (!err) {
        this.setState({ viewObj: res[0] });
      }
    });
  }

  clearModositoObj = () => {
    const modositoObj = {
      id: '',
      ev: '',
      tipus: '',
      mertek: '',
      cegadatid: '',
      penznemid: '',
      banktipusid: '',
      statusz: 'AKTIV'
    };
    this.setState({ modositoObj });
  }

  toggleNezet = () => {
    this.setState({ modalNezet: !this.state.modalNezet });
  }

  toggleFelvitel = () => {
    this.setState({ modalFelvitel: !this.state.modalFelvitel });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  toggleValtozas = () => {
    this.setState({ modalValtozas: !this.state.modalValtozas });
  }

  handleEditClick = (id) => {
    _muvelet = 1;
    this._currentEditId = id;
    this.fillModositoObj();
    this.getAktivBanktipus();
  }

  handleNewClick = () => {
    _muvelet = 0;
    this.getAktivPenznem();
    this.getAktivCegadat();
    this.getAktivBanktipus();
    this.clearModositoObj();
    this.toggleFelvitel();
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  handleViewClick = (id) => {
    this._currentViewId = id;
    this.getViewObj();
    this.toggleNezet();
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        { this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA'], false) && (
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell} onClick={() => this.handleViewClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-view-' + cell} delay={10}>
              {'Megtekintés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        { this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell, row)} />
            {/* <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} /> */}
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-edit-' + cell} delay={10}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-delete-' + cell} delay={10}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  /**
  * Visszaadja az apartmanhoz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  felhasznalvaFormatter = (cell) => {
    return cell ? 'Igen' : 'Nem';
  }

  // 2023.10.02 CLOUDUI START
  // addBankszamla = (event, inflacioObj) => {
    // let sendObj = { ...inflacioObj };
    // sendObj.tipus = 'BANK';
    // sendObj.cegadatid = inflacioObj.cegadat;
    // sendObj.penznem = {
    //   id: inflacioObj.penznem
    // };
    // sendObj.banktipus = {
    //   id: inflacioObj.banktipus
    // };
    // 2023.10.02 CLOUDUI END
  addBankszamla = (event, bankszamlaObj) => {
    const { modositoObj } = this.state;
    let bean = bankszamlaObj;
    bean.tipus = 'BANK';
    bean.szamlaszam = NumberFormatter.removeSpacesFromString(this.state.modositoObj.szamlaszam);
    bean.ibanszam = NumberFormatter.removeSpacesFromString(this.state.modositoObj.ibanszam);

    // 2023.10.02 CLOUDUI START
    // this.emptyToNull(sendObj);
    // Services.addBankszamla(sendObj, (err) => {
    // 2023.10.02 CLOUDUI END
    this.emptyToNull(bankszamlaObj);
    this.setState({ addButtonLoading: true });
    Services.addBankszamla(bean, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Bankszámla felvéve!');
      }
      this.setState({ addButtonLoading: false });
    });
  }

  // 2023.10.02 CLOUDUI START
  // updateBankszamla = (event, inflacioObj) => {
    // let sendObj = { ...inflacioObj };
    // sendObj.id = this._currentEditId;
    // sendObj.cegadatid = sendObj.cegadat;
    // sendObj.banktipus = { id: sendObj.banktipus };
    // sendObj.penznem = { id: sendObj.penznem };
    // sendObj.tipus = 'BANK';

    // Services.existsNew(sendObj.cegadat, (err, res) => {
  // 2023.10.02 CLOUDUI END
  updateBankszamla = (event, bankszamlaObj) => {
    let bean = bankszamlaObj;
    bean.id = this._currentEditId;
    bean.tipus = 'BANK';
    bean.szamlaszam = NumberFormatter.removeHyphensFromString(this.state.modositoObj.szamlaszam);
    bean.ibanszam = NumberFormatter.removeHyphensFromString(this.state.modositoObj.ibanszam);

    this.setState({ modifyButtonLoading: true });
    Services.existsNew(bean.cegadatid, (err, res) => {
    if (!err) {
        if (res[0].hiba === null) {
          // 2023.10.02 CLOUDUI START
          // Services.editBankszamla(sendObj, this._currentEditId, (err2, res2) => {
          // 2023.10.02 CLOUDUI END
          Services.editBankszamla(bean, (err2) => {
            if (!err2) {
              this.toggleFelvitel();
              this.updateTable();
              this.props.globals.addSuccess('Bankszámla módosítva!');
            }
          });
        } else {
          // 2023.10.02 CLOUDUI START
          // this.setState({ errorFromServer: res[0].hiba, idFromServer: res[0].id, idFromForm: inflacioObj.cegadatid, submitObj: inflacioObj }, () => {
          // 2023.10.02 CLOUDUI END
          this.setState({
            errorFromServer: res[0].hiba,
            idFromServer: res[0].id,
            idFromForm: bankszamlaObj.cegadatid,
            submitObj: bankszamlaObj
          }, () => { 
          this.toggleValtozas();
          });
        }
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  editBankszamla = (id) => {
    let submitObj = JSON.parse(JSON.stringify(this.state.submitObj));
    let bean = submitObj;
    bean.id = this._currentEditId;
    bean.tipus = 'BANK';
    bean.szamlaszam = NumberFormatter.removeSpacesFromString(submitObj.szamlaszam);
    bean.ibanszam = NumberFormatter.removeSpacesFromString(submitObj.ibanszam);
    // 2023.10.02 CLOUDUI START
    // Services.editBankszamla(submitObj, this._currentEditId, (err2, res2) => {
    // 2023.10.02 CLOUDUI END
    this.setState({ modifyButtonLoading: true });
  Services.editBankszamla(bean, (err2) => {
    if (!err2) {
        this.setState({ modalValtozas: false }, () => {
          this.setState({ modalFelvitel: false }, () => {
            this.updateTable();
            this.props.globals.addSuccess('Bankszámla módosítva!');
          });
        });
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteBankszamla = (id) => {
    this.toggleTorles();
    this.setState({ deleteButtonLoading: true });
    Services.deleteBankszamla(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Bankszámla törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  filterType = (cell) => {
    // just return type for filtering or searching.
    return cell.caption;
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  renderBaseTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
    };

    // 2023.10.02 CLOUDUI START
    // const statusType = {
    //   true: 'Aktív',
    //   false: 'Inaktív'
    // };
    // 2023.10.02 CLOUDUI END

    const columns = [
      {
        dataField: 'nev',
        text: 'Bank név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'ceg',
        text: 'Cégnév',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'szamlaszam',
        text: 'Számlaszám',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'szamlanev',
        text: 'Bankszámla neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
        align: 'center'
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        formatter: this.statusFormatter,
        style: { whiteSpace: 'normal' },
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        align: 'center'
      },
      {
        dataField: 'fokonyviszam',
        text: 'Főkönyviszám',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter,
        style: { width: 100 },
      },
    ];

    return (
      <BootstrapTable
        bootstrap4
        keyField="id"
        columns={columns}
        data={this.state.baseJson}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  // 2023.10.02 CLOUDUI START
  // renderAdatok = (id) => {
  //   let szamlaObj = this.state.baseJson.find(szamlaObj => szamlaObj.id === id);
  //   return (
  //     <div>
  //       <h6>Számlaszám információ:</h6>
  //       <b>Számlaszám: </b>{szamlaObj.szamlaszam}<br />
  //       <b>Számlaszám neve: </b>{szamlaObj.nev}<br />
  //       <b>Főkönyvi szám: </b>{szamlaObj.fokonyviszam}<br />
  //       <b>IBAN szám: </b>{szamlaObj.iban}<br />
  //       <b>SWIFT: </b>{szamlaObj.swift}<br />
  //       <b>Pénznem: </b>{szamlaObj.penznem && (szamlaObj.penznem.nev + '(' + szamlaObj.penznem.jel + ') - ' + szamlaObj.penznem.azonosito)}<br />
  //       <b>Státusz: </b>{szamlaObj.statusz && szamlaObj.statusz.caption}<br /><br />
  //       <h6>Bank információ:</h6>
  //       <b>Név: </b>{szamlaObj.banktipus.nev}<br />
  //       <b>Azonosító: </b>{szamlaObj.banktipus.azonosito}<br />
  //       <b>Cím: </b>{szamlaObj.banktipus.cim}<br />
  //       <b>Szám: </b>{szamlaObj.banktipus.szam}<br /><br />
  //       <h6>Cég információ:</h6>
  //       <b>Név: </b>{szamlaObj.cegnev}<br />
  //       <b>Típus: </b>{szamlaObj.cegadattipus && szamlaObj.cegadattipus.caption}<br />
  //     </div>
  //   );
  // }
  // 2023.10.02 CLOUDUI END

  renderAdatok = () => {
    let szamlaObj = this.state.viewObj ? this.state.viewObj : {};
    return (
      <div>
        <h6>Számlaszám információ:</h6>
        <b>Számlaszám: </b>
        {NumberFormatter.addSpacesToString(szamlaObj.szamlaszam, NumberFormatter.BANKSZAMLA)}
        <br />
        <b>Számlaszám neve: </b>
        {szamlaObj.nev}
        <br />
        <b>Főkönyvi szám: </b>
        {szamlaObj.fokonyviszam}
        <br />
        <b>IBAN szám: </b>
        {NumberFormatter.addSpacesToString(szamlaObj.ibanszam, NumberFormatter.IBAN)}
        <br />
        <b>SWIFT: </b>
        {szamlaObj.swift}
        <br />
        <b>Pénznem: </b>
        {szamlaObj.penznem}
        <br />
        <b>Státusz: </b>
        {szamlaObj.statusz}
        <br />
        <b>Elérhetőségek: </b>
        {szamlaObj.cim}
        <br />
        <br />
        <h6>Bank információ:</h6>
        <b>Név: </b>
        {szamlaObj.banknev}
        <br />
        <b>Azonosító: </b>
        {szamlaObj.bankazonosito}
        <br />
        <b>Cím: </b>
        {szamlaObj.bankcim}
        <br />
        <b>Szám: </b>
        {szamlaObj.bankszam}
        <br />
        <br />
        <h6>Cég információ:</h6>
        <b>Név: </b>
        {szamlaObj.cegnev}
        <br />
        <b>Típus: </b>
        {szamlaObj.cegtipus}
        <br />
      </div>
    );
  }

  render() {
    const { modositoObj } = this.state;
    return (
      <div>
        { this.props.globals.hasRole(['PENZUGYKOZOS_BANKSZAMLA'], true) && (
          <div className="row">
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>Új számlaszám</Button>
            </div>
          </div>
        )}
        {{
          QUERY: (<QueryEmptyState
            hasImage
          />),
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />),
          TABL: (this.renderBaseTable())
        }[this.state.currentStatusBaseTable]}
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader>Megtekintés</ModalHeader>
          {/* 2023.10.02 CLOUDUI START
            <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          2023.10.02 CLOUDUI END*/}
          <ModalBody>{this.state.modalNezet ? this.renderAdatok() : <div />}</ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={this.toggleNezet} className="btn-cursor-pointer">
              {'Vissza'}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>
            {'Valóban törölni kívánod a kiválasztott tételt?'}
          </ModalBody>
          <ModalFooter>
            <ProgressButton className="btn-cursor-pointer" color="primary" loading={this.state.deleteButtonLoading} onClick={() => this.deleteBankszamla(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal size="lg" isOpen={this.state.modalFelvitel} toggle={this.toggleFelvitel} className={this.props.className} backdrop="static" >
          <RFForm
            modal
            onSubmit={_muvelet === 0 ? this.addBankszamla : this.updateBankszamla}
            title={_muvelet === 0 ? "Új számlaszám rögzítése" : "Meglévő számlaszám módosítása"}
            footer={
              <>
                <ProgressButton loading={_muvelet === 0 ? this.state.addButtonLoading : this.state.modifyButtonLoading} color="primary">Mentés</ProgressButton>
                {' '}
                <Button type="button" color="secondary" onClick={this.toggleFelvitel} >Mégsem</Button>
              </>
            }
          >
            <h5>Alapadatok:</h5>
            <div className="row">
              <div className="col-md-4">
                <Label for='szamlaszam'>
                  Számlaszám: *
                </Label>
                <Input
                  name="szamlaszam"
                  id="szamlaszam"
                  required
                  // numberOnlyWhole
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value ? value.replace(/[^\d]/g, "") : '';
                    this.setState((prevState) => ({ modositoObj: {
                      ...prevState.modositoObj,
                      szamlaszam: value
                    }}));
                  }}
                  maxLength={26}
                  disabled={_muvelet === 1}
                  value={modositoObj && NumberFormatter.addHyphensToStringBankszamla(modositoObj.szamlaszam)} 
                />
              </div>
              <div className="col-md-4">
                <RFField
                  label="Bankszámla neve:"
                  name="nev"
                  required
                  value={modositoObj && modositoObj.nev}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  label="Főkönyvi szám: *"
                  name="fokonyviszam"
                  required
                  value={modositoObj && modositoObj.fokonyviszam}
                  disabled={_muvelet !== 0}
                />
              </div>
              <div className="col-md-4">
                <Label for='ibanszam'>
                  IBAN szám:
                </Label>
                <Input
                  name="ibanszam"
                  id="ibanszam"
                  // numberOnlyWhole
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value ? value.replace(/[^a-zA-Z0-9]/g, "") : '';
                    
                    this.setState((prevState) => ({ modositoObj: {
                      ...prevState.modositoObj,
                      ibanszam: value
                    }}));
                  }}
                  maxLength={34}
                  disabled={_muvelet === 1}
                  value={modositoObj && NumberFormatter.addHyphensToStringIBAN(modositoObj.ibanszam)} 
                />
              </div>
              <div className="col-md-4">
                <RFField
                  label="SWIFT kód: "
                  name="swift"
                  value={modositoObj && modositoObj.swift}
                  disabled={_muvelet === 1}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="select"
                  required
                  name="penznemid"
                  label="Pénznem: *"
                  value={modositoObj && modositoObj.penznemid}
                  defaultSelect={<option value="">Válassz pénznemet...</option>}
                  selectOptions={this.state.aktivPenznem}
                  disabled={_muvelet === 1}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="select"
                  name="banktipusid"
                  label="Banktípus: *"
                  required
                  value={modositoObj && modositoObj.banktipusid}
                  defaultSelect={<option value="">Válassz banktípust...</option>}
                  selectOptions={this.state.aktivBanktipus}
                  disabled={_muvelet === 1}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="select"
                  name="cegadatid"
                  label="Cégadat: *"
                  required
                  value={modositoObj && modositoObj.cegadatid}
                  defaultSelect={<option value="">Válassz cégadatot...</option>}
                  selectOptions={this.state.aktivCegadat}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="select"
                  name="statusz"
                  label="Státusz: *"
                  required
                  value={modositoObj && modositoObj.statusz}
                  defaultSelect={<option value="">Válassz státuszt...</option>}
                  selectOptions={this.state.statuszOptions}
                />
              </div>
            </div>
            <h5>Elérhetőségek:</h5>
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="Cím: " name="cim" id="cim" value={modositoObj && modositoObj.cim} maxLength="50" />
              </div>
            </div>
            <Modal isOpen={this.state.modalValtozas} toggle={this.toggleValtozas} className={this.props.className} backdrop="static">
              <ModalHeader>Cégadat módosult</ModalHeader>
              <ModalBody style={{ whiteSpace: 'pre-wrap' }}>
                {this.state.errorFromServer}
              </ModalBody>
              <ModalFooter>
                <Button type="button" className="btn-cursor-pointer" color="primary" onClick={() => this.editBankszamla(this.state.idFromServer)}>Igen</Button>
                <Button type="button" className="btn-cursor-pointer" color="secondary" onClick={() => this.editBankszamla(this.state.idFromForm)}>Nem</Button>
                <Button type="button" className="btn-cursor-pointer" color="secondary" onClick={() => this.toggleValtozas()}>Mégsem</Button>
              </ModalFooter>
            </Modal>
          </RFForm>
        </Modal>
      </div>
    );
  }
}

BankszamlaLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object,
  className: PropTypes.string,
};

export default BankszamlaLista;
